import { FC } from 'react';
import { ID } from '@datassential/platform-ui-lib';
import Modal from '@components/Modal/Modal';
import Loader from '@components/new/Loader/Loader';
import CategoryLensExamplePosts from './CategoryLensExamplePosts';
import { usePostsByKeywordAndLrCategory } from '@apiHooks/usePostsByKeywordAndLrCategory';
import './CategoryLensPostsPopup.scss';

interface CategoryLensPostsPopupProps {
    isOpened: boolean;
    keywordId: number | null;
    keywordName: string;
    growth: number;
    lrCategoryId: ID;
    onClose: () => void;
}

const CategoryLensPostsPopup: FC<CategoryLensPostsPopupProps> = ({
    isOpened,
    keywordId,
    keywordName,
    growth,
    lrCategoryId,
    onClose,
}) => {
    const { data: posts, isLoading } = usePostsByKeywordAndLrCategory(keywordId, lrCategoryId);

    return (
        <Modal
            isOpened={isOpened}
            close={onClose}
            closeOnEsc
            closeOnOutsideClick
            isHiddenCloseButton={!isLoading}
            className="CategoryLensPostsPopup"
        >
            {isLoading ? (
                <Loader className="CategoryLensPostsPopup__loader"/>
            ) : (
                <CategoryLensExamplePosts
                    data={posts}
                    keywordName={keywordName}
                    growth={growth}
                    onClose={onClose}
                />
            )}
        </Modal>
    );
};

export default CategoryLensPostsPopup;
